import { Component, OnInit } from "@angular/core";
import { CtButtonParameters, CtCardParameters, CtWidgetConfiguration } from "@ctsolution/ct-framework";
import {
  CompanyUiCustomizationService, DEFAULT_LABEL
} from "../../core/lib/company-ui/company.ui-customization.service";
import { GeneralService } from "../../core/lib/general.service";
import { GroupController } from "../../core/controllers/group.controller";
import { GroupService } from "../../core/lib/group.service";
import { RoleService } from "../../core/lib/role.service";
import { groupMenuItem } from "../../shared/menu/menu.items";
import { JwtService } from "../../core/lib/jwt.service";
import { Group } from "../../core/interfaces/group";
import { CompanyCustomConfiguration } from "../../core/interfaces/company-custom-configuration";
import { FlowService } from "src/app/core/lib/flow.service";
import { ProfileController } from "../../core/controllers/profile.controller";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [GroupController, ProfileController]
})
export class HomeComponent implements OnInit {

  sendLettersButtonParameters: CtButtonParameters = CtButtonParameters.create((event: any) => {

    event.stopPropagation();
    this._general.navigateTo(["nuova-spedizione"]);

  })
    .setMaterialIcon("arrow_forward")
    .setContainerClass("text-right");

  sendLettersCardParameters: CtCardParameters = CtCardParameters.create(() => {
  })
    .setTitle("Nuova spedizione")
    .setText("Crea documenti online e spediscili in formato cartaceo o digitale.")
    .setMaterialIcon("local_post_office")
    .setBackgroundClass("bg-warning")
    .setTextColor("text-white")
    .setCtButton(this.sendLettersButtonParameters);

  ordersWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["/ordini"]))
    .setTitle("Ordini")
    .setText("Visualizza gli ordini effettuati.")
    .setBackgroundClass("bg-success")
    .setMaterialIcon("list_alt");

  trackingWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["/tracking"]))
    .setTitle("Tracking")
    .setText("Segui lo stato delle spedizioni")
    .setBackgroundClass("bg-purple")
    .setMaterialIcon("local_shipping");

  quotationsWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["/preventivi"]))
    .setTitle("Preventivi")
    .setText("Gestisci i tuoi preventivi.")
    .setBackgroundClass("bg-megna")
    .setMaterialIcon("fact_check");

  addressBookWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["/amministrazione/rubrica"]))
    .setTitle("Rubrica")
    .setText("Gestisci i tuoi contatti.")
    .setBackgroundClass("bg-megna")
    .setMaterialIcon("contacts");

  widgets: CtWidgetConfiguration[] = [this.ordersWidget, this.trackingWidget];

  groupWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["/amministrazione", DEFAULT_LABEL.GROUPS.toLowerCase()]))
    .setTitle(DEFAULT_LABEL.GROUPS)
    .setText(`Gestisci i tuoi ${DEFAULT_LABEL.GROUPS.toLowerCase()}`)
    .setBackgroundClass("bg-danger")
    .setMaterialIcon("group");

  usersWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["amministrazione", "utenti"]))
    .setTitle("Utenti")
    .setText(`Gestisci i tuoi utenti`)
    .setBackgroundClass("bg-olive")
    .setMaterialIcon("person");

  settingsWidget: CtWidgetConfiguration = CtWidgetConfiguration.create(() => this._general.navigateTo(["amministrazione", "impostazioni"]))
    .setTitle("Impostazioni")
    .setText(`Gestisci le impostazioni del tuo profilo`)
    .setBackgroundClass("bg-info")
    .setMaterialIcon("admin_panel_settings");

  administrativeWidgets: CtWidgetConfiguration[] = [];

  groupInfoCardParameters?: CtCardParameters;

  // Card Business Intelligence
  biReportCardParameters?: CtCardParameters;
  biEnabled: boolean = false;

  // Bottone per la card Business Intelligence
  biReportButtonParameters: CtButtonParameters = CtButtonParameters.create((event: any) => {

    event.stopPropagation();

    // Chiama l'API per recuperare l'URL del dashboard SSO
    this.profileController
      .getSSODashboard()
      .then((biUrl: string) => {
        // Apre il link in una nuova tab
        window.open(biUrl, '_blank');
      })
      .catch((error) => {
        console.error('Errore recupero URL BI Dashboard:', error);
        // TODO: gestire l'errore mostrando un messaggio all'utente
      });

  })
    .setMaterialIcon("arrow_forward")
    .setContainerClass("text-right");

  constructor(
    private _general: GeneralService,
    private companyUiService: CompanyUiCustomizationService,
    private groupController: GroupController,
    private groupService: GroupService,
    private roleService: RoleService,
    private _jwt: JwtService,
    private flowService: FlowService,
    private profileController: ProfileController
  ) {

  }

  ngOnInit() {

    this.setupAdministrativeWidgets()
      .then(() => this.setupQuotationsWidget()
        //.then(() => this.setupAddressBook()
          .then(() => this.setupBiReportCard()
            .then(() => this.setGroupData())));

  }

  setGroupData() {

    this.groupController
      .userGroup()
      .then((userGroup: Group) => {

        const groupResidueBudget: string = this.groupService.getBudgetResidueLabel(userGroup);

        this.groupInfoCardParameters = CtCardParameters
          .create(() => {
          })
          .setTitle(`${userGroup.Code} - ${userGroup.Name}`)
          .setText(`Budget residuo: ${isNaN(+groupResidueBudget) ? groupResidueBudget : (groupResidueBudget + " €")}`);

        this.groupWidget
          .setTitle(groupMenuItem.name)
          .setText(`Gestisci i tuoi ${groupMenuItem.name}`)
          .setAction(() => this._general.navigateTo(["/amministrazione", groupMenuItem.state]));

      });

  }

  private async setupAddressBook(){

    const addressBookEnabled: boolean = await this._jwt.getAddressBookEnabled();

    if (!addressBookEnabled && this.widgets.includes(this.addressBookWidget)) {

      this.widgets.splice(this.widgets.indexOf(this.addressBookWidget), 1);

    } else if (addressBookEnabled && !this.widgets.includes(this.addressBookWidget)) {

      this.widgets.push(this.addressBookWidget);

    }

    //Momentaneamente non voluto in dashboard

  }

  private async setupAdministrativeWidgets() {

    const companyConfiguration: CompanyCustomConfiguration | null = await this._jwt.getCompanyCustomConfiguration();

    const hasAdministrativeAccess: boolean = await this.roleService.hasAdministrativeAccess();

    if (hasAdministrativeAccess) {

      this.administrativeWidgets = [this.groupWidget];

      if (companyConfiguration?.UserManagementEnabled) {

        this.administrativeWidgets.push(this.usersWidget);

      }

    }

    if (companyConfiguration?.SettingsManagementEnabled) {

      this.administrativeWidgets.push(this.settingsWidget);

    }

  }

  private async setupQuotationsWidget() {

    const autoAcceptPrintQuote: boolean = await this._jwt.getAutoAcceptPrintQuote();

    if (autoAcceptPrintQuote && this.widgets.includes(this.quotationsWidget)) {

      this.widgets.splice(this.widgets.indexOf(this.quotationsWidget), 1);

    } else if (!autoAcceptPrintQuote && !this.widgets.includes(this.quotationsWidget)) {

      this.widgets.push(this.quotationsWidget);

      this.flowService.getApprovalCount()

      this.flowService.getToSignCount()

    }

  }

  /**
   * Configura la card Business Intelligence se abilitata
   * La card viene mostrata solo se BiEnabled è true nel claims
   */
  private async setupBiReportCard() {

    this.biEnabled = await this._jwt.getBiEnabled();

    if (this.biEnabled) {

      this.biReportCardParameters = CtCardParameters
        .create(() => {
          // Chiama l'API per recuperare l'URL del dashboard SSO
          this.profileController
            .getSSODashboard()
            .then((biUrl: string) => {
              // Apre il link in una nuova tab
              window.open(biUrl, '_blank');
            })
            .catch((error) => {
              console.error('Errore recupero URL BI Dashboard:', error);
              // TODO: gestire l'errore mostrando un messaggio all'utente
            });
        })
        .setTitle("Business Intelligence")
        .setText("Accedi ai report e alle statistiche delle spedizioni")
        .setMaterialIcon("pie_chart")
        .setBackgroundClass("bg-success")
        .setTextColor("text-white")
        .setCtButton(this.biReportButtonParameters);

    }

  }

}
